import React, { useState } from "react";
import postData from "../feedpost/postdata";
import ReactPlayer from "react-player";
import play from "../../assets/play.png";
import groupimg from "../../assets/groupimg.png";
import userimg from "../../assets/user.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
export default function FeedPost() {
    const [playingIndex, setPlayingIndex] = useState(null);
    const [expandedPosts, setExpandedPosts] = useState(Array(postData.length).fill(false)); // Ensure consistent hook call

    // Toggle Read More state
    const toggleReadMore = (index) => {
        setExpandedPosts((prev) => {
            const updated = [...prev];
            updated[index] = !updated[index]; // Toggle specific post
            return updated;
        });
    };

    return (
        <div className="w-full">
            {postData.map((post, index) => {
                const maxLength = 150; // Character limit
                const isExpanded = expandedPosts[index]; // Always read from state array

                return (
                    <div key={index} className="mb-8">
                        <div className="feeds w-full bg-[#F7F7F7] p-8">
                            <div className="flex items-center justify-between space-x-3">
                                <div className="flex items-center">
                                    <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                                        <img src={post.profileimg} alt="Profile" className="w-full h-full object-cover" />
                                    </div>
                                    <div className="feed-title pl-4">
                                        <p className="font-semibold">{post.username}</p>
                                        <p className="flex text-sm text-[#747474]">
                                            {post.date} |
                                            <span className="flex items-center ml-1 cursor-pointer">
                                                <img src={post.globalIcon} alt="" className="mr-1 " /> Public
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <button className="bg-[#095228] text-[#FFFFFF] follow-cta">Follow</button>
                            </div>

                            {/* Post Content with Read More */}
                            <p className="mt-4 mb-4 text-black text-justify">
                                {isExpanded ? post.content : `${post.content.slice(0, maxLength)}...`}

                                {post.content.length > maxLength && (
                                    <button
                                        onClick={() => toggleReadMore(index)}
                                        className="text-[#095228] italic hover:underline font-semibold"
                                    >
                                        {isExpanded ? "Read Less" : "Read More"}
                                    </button>
                                )}</p>
                            {/* Media Handling */}
                            <div
                                className={`grid gap-2 
                                        ${post.media?.length === 1 ? "grid-cols-1"
                                        : post.media?.length === 2 ? "grid-cols-2"
                                            : post.media?.length === 3 ? "grid-cols-3 xs:grid-cols-3 sm:grid-cols-5"
                                                : post.media?.length === 4 ? "grid-cols-3 xs:grid-cols-5 sm:grid-cols-4"
                                                    : "grid-cols-5"} `}>
                                {post.media?.map((media, imgIndex) => {
                                    const isPlaying = playingIndex === `${index}-${imgIndex}`;
                                    const isVideo = media.endsWith(".mp4") || media.endsWith(".webm") || media.endsWith(".ogg");

                                    return isVideo ? (
                                        // Hide videos on mobile
                                        <div key={imgIndex} className="relative w-full rounded-lg overflow-hidden hidden md:block">
                                            <ReactPlayer
                                                url={media}
                                                playing={isPlaying}
                                                controls
                                                width="100%"
                                                height={post.media.length === 1 ? "500px" : "100%"}
                                                className="rounded-lg"
                                                light={groupimg}
                                                playIcon={
                                                    <button className="absolute inset-0 flex items-center justify-center bg-opacity-50 rounded-lg">
                                                        <img src={play} alt="Play" className="player" />
                                                    </button>
                                                }
                                                onClickPreview={() => setPlayingIndex(`${index}-${imgIndex}`)}
                                            />
                                        </div>
                                    ) : (
                                        <img
                                            key={imgIndex}
                                            src={media}
                                            alt={`Post ${index} Media ${imgIndex}`}
                                            className="w-full h-full rounded-lg shadow-lg object-cover max-h-[300px]"
                                        />
                                    );
                                })}
                            </div>

                            {/* Social Buttons */}
                            <div className="react-social-cta flex justify-between items-center mt-8">
                                <div className="flex space-x-4">
                                    <button className="like flex items-center space-x-1 bg-[#BE1F2E] text-white px-3 py-1">
                                        <img src={post.likeIcon} alt="Like" className="mr-1 " /> {post.likes}k
                                    </button>
                                    <button className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1 ">
                                        <img src={post.commentIcon} alt="Comment" className="mr-1" /> {post.comments}k
                                    </button>
                                    <button className="eye flex items-center space-x-1 text-black">
                                        <img src={post.viewIcon} alt="Views" className="mr-1" /> {post.views} Views
                                    </button>
                                </div>
                                <button className="flex items-center space-x-1 text-green-500">
                                    <img src={post.shareIcon} alt="Share" className="" />
                                </button>
                            </div>
                        </div>

                        {/* Comment Section */}
                        <div className="hidden md:block">
                            <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5 ">
                                <div className="flex items-center w-full">
                                    <img src={post.profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                    <input type="text" placeholder="Add a comment..." className="flex-1 outline-none px-3 text-gray-700 bg-transparent" />
                                </div>
                                <div className="flex space-x-2">
                                    <button>
                                        <img src={post.smileyIcon} alt="Smiley" className="w-8" />
                                    </button>
                                    <button className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                );
            })}

        </div>
    );
}
